import { DEVICES, pickThemeColor, pickThemeFontStyles } from '@/theme';
import { Link } from '@/ui';
import styled from 'styled-components';

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const StyledWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 1rem;
`;

export const StyledLink = styled(Link)`
  margin: 0;
  color: ${pickThemeColor('ORANGE_PRIMARY')};
  text-decoration: underline;
  ${pickThemeFontStyles('16', '24')};

  &:hover {
    color: ${pickThemeColor('ORANGE_PRIMARY')};
    text-decoration: none;
  }
`;

export const StyledSecondaryTitle = styled.div`
  color: ${pickThemeColor('BLACK_PRIMARY')};
  ${pickThemeFontStyles('16', '26', 'SEMI_BOLD')};

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('20', '26', 'SEMI_BOLD')};
  }
`;
